import { render, staticRenderFns } from "./linkSelect.vue?vue&type=template&id=68c86bc6&scoped=true&"
import script from "./linkSelect.vue?vue&type=script&lang=js&"
export * from "./linkSelect.vue?vue&type=script&lang=js&"
import style0 from "./linkSelect.vue?vue&type=style&index=0&id=68c86bc6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c86bc6",
  null
  
)

export default component.exports